import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "integerBeginTime",
    "integerEndTime",
    "beginTimeHours",
    "beginTimeMinutes",
    "endTimeHours",
    "endTimeMinutes",
  ];

  connect() {
    this.initTimeSelects();

  }

  initTimeSelects() {
    const beginTimeSecondsFromMidnight = parseInt(this.integerBeginTimeTarget.value);
    const endTimeSecondsFromMidnight = parseInt(this.integerEndTimeTarget.value);
    this.convertIntegerToTime(beginTimeSecondsFromMidnight, "begin");
    this.convertIntegerToTime(endTimeSecondsFromMidnight, "end");
  }

  convertIntegerToTime(secondsFromMidnight, targetedInput) {
    const hoursWithDecimal = secondsFromMidnight / 3600;
    const plainHours = Math.floor(hoursWithDecimal);
    const rest = (hoursWithDecimal) % 1;
    const plainMinutes = Math.floor(rest * 60);
    targetedInput == "begin" ? this.insertTimeToBeginTarget(plainHours, plainMinutes) : this.insertTimeToEndTarget(plainHours, plainMinutes);
  }

  insertTimeToBeginTarget(hours, minutes) {
    this.beginTimeHoursTarget.value = hours;
    this.beginTimeMinutesTarget.value = minutes;
  }

  insertTimeToEndTarget(hours, minutes) {
    this.endTimeHoursTarget.value = hours;
    this.endTimeMinutesTarget.value = minutes;
  }

  handleBeginChange() {
    const hours = parseInt(this.beginTimeHoursTarget.value);
    const minutes = parseInt(this.beginTimeMinutesTarget.value);
    if (this.valueValid(hours, minutes)) {
      this.integerBeginTimeTarget.value = this.convertTimeToInteger(hours, minutes);
    }
  }

  handleEndChange() {
    const hours = parseInt(this.endTimeHoursTarget.value);
    const minutes = parseInt(this.endTimeMinutesTarget.value);
    if (this.valueValid(hours, minutes)) {
      this.integerEndTimeTarget.value = this.convertTimeToInteger(hours, minutes);
    }
  }

  convertTimeToInteger(hours, minutes) {
    return (hours * 3600) + (minutes * 60);
  }

  valueValid(hours, minutes) {
    return ((hours >= 0 && hours <= 23) && (minutes >= 0 && minutes <= 59));
  }
}
